import { render, staticRenderFns } from "./TTLRBUNA.vue?vue&type=template&id=00e2b426&scoped=true"
import script from "./TTLRBUNA.vue?vue&type=script&lang=js"
export * from "./TTLRBUNA.vue?vue&type=script&lang=js"
import style0 from "./TTLRBUNA.vue?vue&type=style&index=0&id=00e2b426&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e2b426",
  null
  
)

export default component.exports